if (!customElements.get('cart-item-addon')) {

  var CartItemAddon = class extends HTMLElement {

    connectedCallback() {

      if (this.expandButton) {
        this.expandButton.addEventListener("click", this.toggleExpand.bind(this));
      }

      if (this.removeButton) {
        this.removeButton.addEventListener("click", this.onClickRemoveItem.bind(this));
      }

    }

    // Expand / Collapse Logic

    toggleExpand() {

      if (this.expanded) {
        this.collapse();
      }
      else {
        this.expand();
      }

    }
    collapse() {
      this.classList.remove("addon--expanded");
    }
    expand() {
      this.classList.add("addon--expanded");
    }

    // Functions

    async onClickRemoveItem(event) {

      event.preventDefault();

      const button = event.target;

      // Show cart loading state (Theme Function)
      const line = this.cartLineItem.querySelector(`[data-index]`).dataset.index;
      this.cartItems.enableLoading(line);

      const data = await this.removeItem();

      // End cart loading state (Theme Function)
      this.cartItems.classList.remove('pointer-events-none');

      // Refresh Cart (Theme Function)
      this.cartItems.refresh();

    }

    async removeItem() {

      const postData = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      postData.body = JSON.stringify({
        id: this.key,
        quantity: 0
      });

      const response = await fetch(theme.routes.cartChange, postData);
      const data = await response.json();

      if (!response.ok) throw new Error(data.errors || response.status);

      return data;

    }

    // Elements

    get expandButton() {
      return this.querySelector(`[data-expand-button]`);
    }
    get removeButton() {
      return this.querySelector(`[data-addon-remove]`);
    }
    get cartLineItem() {
      return this.closest(".cart-item");
    }
    get cartItems() {
      return this.closest("cart-items");
    }

    get expanded() {
      return this.classList.contains("addon--expanded") ? true : false;
    }
    get key() {
      return this.dataset.addonKey;
    }

  };
  window.customElements.define("cart-item-addon", CartItemAddon);

}

if (!customElements.get('addon-examples-drawer')) {

  class AddonExamplesDrawer extends SideDrawer {

    constructor() {
      super();

      

    }

  }

  customElements.define('addon-examples-drawer', AddonExamplesDrawer);

}

var uuid = function () {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}

document.addEventListener("DOMContentLoaded", (event) => {

  document.querySelectorAll(`input[alphanumeric]`).forEach(element => {
    element.addEventListener("input", event => {
      // Get the current value of the input
      const value = event.target.value;

      // Remove any non-alphanumeric characters
      const filteredValue = value.replace(/[^a-zA-Z0-9]/g, '');

      // Set the filtered value back to the input
      event.target.value = filteredValue;
    });
  })

  document.querySelectorAll(`[data-tooltip]`).forEach(element => {
    tippy(element, {
      placement: "left",
      content: element.dataset.tooltip
    });
  })

  document.querySelectorAll(`.swatch-select-container select`).forEach(element => {
    element.addEventListener("change", (event) => {
      const selectedOption = element.options[element.selectedIndex];
      const value = selectedOption.dataset.swatch;
      const container = element.closest(".swatch-select-container");
      container.style = `--swatch-color: ${value};`;
    });
  });

});